module.exports = __webpack_public_path__ + "img/player_jump_005.a5fb8f18.png";